import { defineStore } from 'pinia'
import {computed, ref} from 'vue'
import api from '@/api'
import { useGlobalStore } from '@/store/index'

export const useOrderlistStore = defineStore('orderlist', () =>
{
    const items = ref([])
    const item = ref({})

    const globals = useGlobalStore()

    const apiUrlGetOrderItems = computed(() =>
    {
        return window.app.orderhistory.siteLanguageHrefLang.replace('-', '_') + '/remote/dashboard/'
    })

    const apiUrlGetOrderItem = computed(() =>
    {
        return window.app.orderhistory.siteLanguageHrefLang.replace('-', '_') + '/remote/dashboard/details/'
    })

    async function getOrderItems ()
    {
        let config = {}
        if (window.localStorage && window.localStorage.getItem('einhell-auth-data'))
        {
            config = {
                headers: { 'Authorization': 'Bearer ' + JSON.parse(window.localStorage.getItem('einhell-auth-data')).token }
            }
        }
        await api.get(apiUrlGetOrderItems.value, config)
            .then(response =>
            {
                items.value = response.data
            })
            .catch(() =>
            {
                globals.error = true
            })
    }

    async function getOrderItem (el)
    {
        let config = {}
        if (window.localStorage && window.localStorage.getItem('einhell-auth-data'))
        {
            config = {
                headers: { 'Authorization': 'Bearer ' + JSON.parse(window.localStorage.getItem('einhell-auth-data')).token }
            }
        }
        await api.get(apiUrlGetOrderItem.value + el.id, config)
            .then(response =>
            {
                if (response.data.length)
                {
                    item.value = response.data[0]
                    globals.showOverlay = true
                }
                else
                {
                    item.value = {}
                    globals.error = true
                }
            })
            .catch(() =>
            {
                globals.error = true
            })
    }


    return {
        items,
        item,
        getOrderItems,
        getOrderItem
    }
})
